



































import { computed, defineComponent, ref } from '@vue/composition-api';
import { useAllResources } from '@/store/modules/resources';
import { SamplingCollection } from '@/store/types';
import { ImportableResources, mergeFileResources } from './ImportDataButton';

function readFile(file: File): Promise<string> {
	return new Promise((resolve, reject) => {
		const fr = new FileReader();
		fr.onload = () => {
			resolve(String(fr.result));
		};
		fr.onabort = (err) => {
			reject(err);
		};
		fr.onerror = (err) => {
			reject(err);
		};
		fr.readAsText(file, 'utf8');
	});
}

async function parseFiles(files: File[]) {
	try {
		const parsedFiles = await Promise.all(
			files
				.map(async (file) => {
					const text = await readFile(file);
					return text ? JSON.parse(text) : {};
				})
				.filter((f) => Boolean(f))
		);

		return mergeFileResources(parsedFiles);
	} catch (error) {
		console.warn('error loading files', error);
		return {};
	}
}

export default defineComponent({
	props: {
		buttonText: {
			required: true,
			type: String,
		},
	},
	setup(props, { root }) {
		const dialogIsVisible = ref(false);
		const snackbarMessage = ref('');
		const snackbarIsVisible = ref(false);

		const { isLoaded, samplingCollections } = useAllResources(root.$store);

		const originalDraftIds = computed(() =>
			samplingCollections.value
				?.map(
					(samplingCollection: SamplingCollection) =>
						samplingCollection.meta?.referenceIds?.find((refId) => refId.owner === 'soilstack-draft')?.id
				)
				.filter(Boolean)
		);

		const resourcesState = ref<Partial<ImportableResources>>({});

		const handleFileChange = async (files: File[]) => {
			const resources = await parseFiles(files);
			// TODO: validate resources
			resourcesState.value = resources;
		};

		function onImport() {
			const {
				samples: importSamples,
				samplings: importSamplings,
				samplingCollections: importSamplingCollections,
			} = resourcesState.value;
			const { dispatch } = root.$store;

			const isImportingAlreadySubmittedDraft = importSamplingCollections?.some(
				(samplingCollection: SamplingCollection) => originalDraftIds.value?.includes(samplingCollection.id)
			);

			if (isImportingAlreadySubmittedDraft) {
				dialogIsVisible.value = false;
				snackbarIsVisible.value = true;
				snackbarMessage.value = 'You cannot import a sampling collection that has already been submitted.';
				alert('You cannot import a sampling collection that has already been submitted.');
			} else {
				importSamples && dispatch('samples/setRecords', importSamples);
				importSamplings && dispatch('samplings/setRecords', importSamplings);
				importSamplingCollections && dispatch('samplingCollections/setRecords', importSamplingCollections);
				dialogIsVisible.value = false;
				snackbarIsVisible.value = true;
				snackbarMessage.value = 'Successfully imported data';
			}
		}

		return {
			handleFileChange,
			resourcesState,
			dialogIsVisible,
			onImport,
			snackbarIsVisible,
			snackbarMessage,
			isLoaded,
		};
	},
});
